import React, { useEffect, useState, Fragment } from "react";
import { Select, Form, Input, Button, message, Col, Row, Divider, Popover } from "antd";
import styles from "../management.module.scss";
import { useTranslation } from "react-i18next";
import { CharacterVerify } from "../../../Utility/RegExp";
import { custInfRecordProps } from "../index";
import { useCreateGroup } from "../queries";
import { FilterOutlined } from "@ant-design/icons";

const { Option } = Select;

interface nodeList {
  id: string;
  name: string;
}

interface createGroupProps {
  record: custInfRecordProps;
  devicesNodeInf: any;
  CreateGroupform: any;
  setCurrentPage: any;
  GroupModalvisible: boolean;
}

const CreateGroup = ({ record, CreateGroupform, setCurrentPage, devicesNodeInf }: createGroupProps) => {
  const [FilterNodeList, setFilterNodeList] = useState<nodeList[]>([]);
  const [filterVisible, setFilterVisible] = useState(false);
  const [DeviceSearch, setDeviceSearch] = useState<string | undefined>("any");
  const { t } = useTranslation();
  const { mutateAsync: createGroupMutation } = useCreateGroup();

  useEffect(() => {
    if (devicesNodeInf?.NodeList) {
      // sort array of object
      function compare(a: any, b: any) {
        if (a.id < b.id) {
          return -1;
        }
        if (a.id > b.id) {
          return 1;
        }
        return 0;
      }
      devicesNodeInf?.NodeList.sort(compare);

      setFilterNodeList(devicesNodeInf.NodeList);
    } else {
      setFilterNodeList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [devicesNodeInf?.NodeList]);

  const handleVisibleChange = (visible: boolean) => {
    setFilterVisible(visible);
  };

  function SelectAll() {
    let SelectAllList = FilterNodeList.map((item: nodeList) => (item.name !== "" ? item.name : item.id));
    CreateGroupform.setFieldsValue({
      Device_ID: SelectAllList,
    });
  }

  function ClearAll() {
    CreateGroupform.setFieldsValue({
      Device_ID: [],
    });
  }

  const filterDeviceByLocation = (value: string) => {
    let FilterNodeList = devicesNodeInf.NodeList;
    if (value.length) {
      FilterNodeList = FilterNodeList?.filter((item: any) => value.includes(item.city));
      setFilterNodeList(FilterNodeList);
    } else {
      setFilterNodeList(devicesNodeInf.NodeList);
    }
  };

  const CreateGrouponFinish = (values: any) => {
    values.Device_ID = FilterNodeList.filter(
      (item: any) => values.Device_ID.includes(item.name) || values.Device_ID.includes(item.id)
    ).map((item: any) => item.id);

    createGroupMutation({ values, cid: record.cid })
      .then(() => {
        message.success(t("ISMS.Success"));
        setCurrentPage("2");
        CreateGroupform.resetFields();
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  const content = (
    <div className="formwrap" style={{ width: "380px", padding: "5px" }}>
      <Form.Item label={t("ISMS.Location")} name="city">
        <Select
          // loading={uploading}
          mode="multiple"
          placeholder={t("ISMS.Select")}
          maxTagCount={"responsive"}
          onChange={(value: string) => {
            filterDeviceByLocation(value);
          }}
        >
          {devicesNodeInf?.locationList?.sort().map((item: any, index: number) => {
            return (
              <Option key={index} value={item}>
                {item}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    </div>
  );

  return (
    <Form
      preserve={false}
      name="CreateGroup"
      onFinish={CreateGrouponFinish}
      autoComplete="off"
      form={CreateGroupform}
      className={styles.Form}
      layout="vertical"
    >
      <div className="formwrap">
        <Row gutter={24} justify="start">
          <Col xs={24} sm={24} md={24} lg={9} xl={9}>
            <Form.Item
              label={
                <Fragment>
                  {t("ISMS.Device")}
                  <Popover
                    content={content}
                    trigger="click"
                    visible={filterVisible}
                    onVisibleChange={handleVisibleChange}
                  >
                    {/* <Button type="link">{t("ISMS.Filter")} </Button> */}
                    <Button size="small" type="text" icon={<FilterOutlined />}></Button>
                  </Popover>
                </Fragment>
              }
              name="Device_ID"
              rules={[{ required: true, message: "Deivce is required!" }]}
            >
              <Select
                //   loading={uploading}
                mode="multiple"
                allowClear
                autoClearSearchValue={false}
                placeholder={t("ISMS.Select")}
                maxTagCount={"responsive"}
                onSearch={(value) => {
                  if (value === "") {
                    setDeviceSearch("any");
                  } else {
                    setDeviceSearch(undefined);
                  }
                }}
                dropdownRender={(menu) => (
                  <Fragment>
                    {menu}
                    <Divider style={{ margin: "4px 0" }} />

                    {DeviceSearch && (
                      <Fragment>
                        <Button onClick={() => SelectAll()} style={{ margin: "5px", padding: "3px 5px" }}>
                          {t("ISMS.SelectAll")}
                        </Button>
                        <Button onClick={() => ClearAll()} style={{ margin: "5px", padding: "3px 5px" }}>
                          {t("ISMS.ClearAll")}
                        </Button>
                      </Fragment>
                    )}
                  </Fragment>
                )}
              >
                {FilterNodeList?.map((item, index) => {
                  return (
                    <Option key={index} value={item.name ? item.name : item.id}>
                      {item.name ? item.name : item.id}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={7} xl={7}>
            <Form.Item
              label={t("ISMS.GroupName")}
              name="groupName"
              rules={[{ required: true, message: "Group name is required!" }, CharacterVerify]}
            >
              <Input placeholder={t("ISMS.InputGroupName")} maxLength={30} />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default CreateGroup;
